__turbopack_context__.v({
  "ai-fab-enter": "FloatingAiAssistant-module__mArPJq__ai-fab-enter",
  "ai-fab-ring": "FloatingAiAssistant-module__mArPJq__ai-fab-ring",
  "anchor": "FloatingAiAssistant-module__mArPJq__anchor",
  "button": "FloatingAiAssistant-module__mArPJq__button",
  "icon": "FloatingAiAssistant-module__mArPJq__icon",
  "ring": "FloatingAiAssistant-module__mArPJq__ring",
});
